import { Link } from 'react-router-dom';

const directions = [
  'лидерство',
  'постановка задач',
  'делегирование',
  'контроль',
  'обратная связь',
  'мотивация',
  'управление конфликтами',
  'принятие решений',
  'коммуникация',
  'управление изменениями',
  'управленческие переговоры',
];

const programs = [
  { label: 'Тренинг для руководителей', to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley' },
  { label: 'Делегирование и постановка задач', to: '/menedzhment-i-liderstvo/delegirovanie-i-postanovka-zadach' },
  { label: 'Обратная связь и сложные разговоры', to: '/menedzhment-i-liderstvo/obratnaya-svyaz-i-slozhnye-razgovory' },
  { label: 'Мотивация и управление командой', to: '/menedzhment-i-liderstvo/motivatsiya-i-upravlenie-komandoy' },
  { label: 'Управление конфликтами', to: '/menedzhment-i-liderstvo/trening-po-upravleniyu-konfliktami' },
  { label: 'Управленческие переговоры', to: '/menedzhment-i-liderstvo/upravlencheskie-peregovory' },
  { label: 'Управление изменениями', to: '/menedzhment-i-liderstvo/upravlenie-izmeneniyami' },
];

export default function FutureLeaders() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Кадровый резерв будущих руководителей
        </h2>
        <p className="text-teal-700 font-semibold text-center text-base md:text-lg mb-10">
          Подготовка сотрудника к управленческой роли
        </p>

        <p className="text-base md:text-lg text-gray-700 text-center max-w-3xl mx-auto mb-10 leading-relaxed">
          Переход от специалиста к руководителю требует развития новых компетенций. Возможные направления:
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {directions.map((d) => (
            <span key={d} className="bg-gray-50 border border-gray-200 text-gray-700 px-4 py-2 rounded-full text-sm font-medium">
              {d}
            </span>
          ))}
        </div>

        <p className="text-base text-gray-700 text-center max-w-3xl mx-auto mb-8 leading-relaxed">
          Развитие управленческих компетенций строится в рамках кластера <strong className="font-semibold">«Менеджмент и лидерство»</strong> и связанных программ:
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-8">
          {programs.map((p) => (
            <Link key={p.to} to={p.to} className="bg-white border border-gray-200 text-gray-700 px-5 py-2.5 rounded-lg text-sm font-semibold hover:border-teal-300 hover:text-teal-700 transition-colors whitespace-nowrap cursor-pointer">
              {p.label}
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link to="/menedzhment-i-liderstvo" className="inline-flex items-center gap-2 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer">
            Менеджмент и лидерство — хаб кластера
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}